import _ from 'lodash'
import { BotFlow } from '@feedyou/schema'

import { FeedbotThunk } from '../../../store/types'
import { actions } from '../../../store/flow/flowSlice'
import { botFlowSelector } from '../../../store/flow/selectors/botFlowSelector'
import { convertLegacyVariablesToGlobalStorages } from '../utils/convertLegacyVariablesToGlobalStorages'

export const migrateLegacyVariablesToGlobalStorages = (): FeedbotThunk => (dispatch, getState) => {
  const flow = botFlowSelector(getState())

  // @ts-ignore
  const newFlow: BotFlow = {
    ..._.omit(flow, 'variables'),
    // @ts-ignore
    globalStorages: {
      ...flow?.globalStorages,
      ...convertLegacyVariablesToGlobalStorages(flow?.variables ?? {})
    }
  }

  dispatch(actions.setFlow(newFlow))

  alert(
    'Bot variables have been migrated to global storages. Please save your bot to apply the changes.'
  )
}
